module.exports = __webpack_public_path__ + "img/sa.de4ba976.jpg";